import OperateMain from './modules/operate/operateMain';
new OperateMain();
